// let UrlHref = location.href;
// if (UrlHref.indexOf('his') > -1) {

// } else {

//   location.href = location.href + "?his=his"
// }
import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import {BD_map} from "./baidu-map.js"
import VueAxiosPlugin from 'vue-axios-plugin'
import VueJsonp from 'vue-jsonp'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import SubjectList from '../components/SubjectList.vue'
//import {Subjectcourselist} from './components/SubjectList.js'
import NearCampus from '../components/NearCampus.vue'
import SearchTeachersMap from '../components/SearchTeachersMap.vue'
import FullClass from '../components/FullClass.vue'
import SignUp from '../components/SignUp.vue'
import SearchClass from '../components/SearchClass.vue'
import ConsultationInfo from '../components/ConsultationInfo.vue'
import FooterConsultationInfo from '../components/FooterConsultationInfo.vue'
/*import '../m2/css/style.css'*/
Vue.use(VueAwesomeSwiper/* { default global options } */)
Vue.use(VueAxiosPlugin, {
  // request interceptor handler
  reqHandleFunc: config => config,
  reqErrorFunc: error => Promise.reject(error),
  // response interceptor handler
  resHandleFunc: response => response,
  resErrorFunc: error => Promise.reject(error)
});
Vue.use(VueJsonp)


new Vue({
  el: '#app',
  components:{
    'subject-list':SubjectList,
    'near-campus':NearCampus,
    'search-teachers-map':SearchTeachersMap,
    'full-class':FullClass,
    'sign-up':SignUp,
    'search-class':SearchClass,
    'consultation-info':ConsultationInfo,
    'footer-consultation-info':FooterConsultationInfo
  },
  data: {
    schoolID: myGlobal.schoolID,
    code:myGlobal.code,
    teacherurl: "http://m.souke.xdf.cn/Teacher/" + myGlobal.schoolID + ".html",
    mapurl: "http://m.souke.xdf.cn/Maps/" + myGlobal.schoolID + ".html",
    lng: '',//经度
    lat: '',//纬度
    areaCityPoint: [],//离你最近的校区
    searchVal:"",
    cardIndex:0,
    courselist:[],
    classNumber:'',//立即报名input v-model
    fullclasslist:[],//即将满班课程
    floorArr: [{
      code: '318', title: '学前辅导', icon: 'nav_xueqian.png', titleColor: '#00bb97', shortName: 'xueqian',attr: ''},
      {code: '40', title: '小学辅导', icon: 'nav_xiaoxue.png', titleColor: '#ff8b4c', shortName: 'xiaoxue', attr: ''},
      {code: '414', title: '初中生', icon: 'nav_zhongxue.png', titleColor: '#f1496e', shortName: 'chuzhong', attr: '934'},
      {code: '414', title: '高中生', icon: 'nav_gaozhong.png', titleColor: '#0acda5', shortName: 'gaozhong', attr: '935'},
      {code: '20', title: '大学考试', icon: 'nav_daxue.png', titleColor: '#34d0ff', shortName: 'daxue', attr: ''},
      {code: '145', title: '出国留学', icon: 'nav_chuguo.png', titleColor: '#ff8b4c', shortName: 'chuguo', attr: ''},
      {code: '6', title: '英语学习', icon: 'nav_yingyu.png', titleColor: '#00bb97', shortName: 'yingyu', attr: ''},
      {code: '79', title: '小语种', icon: 'nav_xiaoyuzhong.png', titleColor: '#fd6aa7', shortName: 'xiaoyuzhong', attr: ''},
      {code: '110', title: '夏冬令营', icon: 'nav_lingying.png', titleColor: '#00bb97', shortName: 'lingying', attr: ''}]

  },
  methods: {
    /**
     * 返回校区链接
     * @param schoolID
     * @param code
     * @returns {string}
     */
    areaCityPointURL: function (schoolID, code) {
      return `http://souke.xdf.cn/Campus/${schoolID}-${code}.html`
    },
    classCodeURl(code){
      return `http://m.souke.xdf.cn/course/${this.schoolID}-${code}.html`
    },
    cardIndexClick(index){
      this.cardIndex=index;
    },
    getSearchVal(val){
      this.searchVal=val
    },
    getClassNumberClick(cn){
      this.classNumber=cn
    }
  },
  mounted(){
    let lng, lat, that = this;

    //根据百度地图的经纬度和搜客城市ID调取离你最近课程
    
    BD_map()
      .then((pt)=> {
        return Vue.jsonp(`http://deploy.xdf.cn/api/Soukeapi/souke?method=Area/GetNearAreaByCityPoint&param={"cityId":${this.schoolID},"Longitude":"${pt.lng}","Latitude":"${pt.lat}","size":"2"}&_=1533628113107`, {
          callbackQuery: 'callback',
          callbackName: ''
        })
      }).then((res)=> {

      this.areaCityPoint = res
    }, (reg)=> {

    });


    //调取课程信息
    let floorArrIndex=0;
    let callbackFn=(floorArrIndex,res,i)=>{
      if(res.length>0){
        let obj={
          code: this.floorArr[i].code,
          title: this.floorArr[i].title,
          icon:  this.floorArr[i].icon,
          titleColor:  this.floorArr[i].titleColor,
          shortName:  this.floorArr[i].shortName,
          attr: this.floorArr[i].attr,
          list:res
        };
        this.courselist.push(obj);
      }
      if(floorArrIndex+1>=this.floorArr.length){

      }else {

      }
    };
    for (var i = 0; i < this.floorArr.length; i++) {
      let obj = this.floorArr[i];
      let fn=(i)=>{
        Vue.jsonp(`http://m.xdf.cn/seo/course1`, {
          ccc:obj.code,
          soukecityid:this.schoolID,
          attr:obj.attr,
          callbackQuery: 'callback',
          callbackName: ''
        }).then((res)=>{
          callbackFn(floorArrIndex,res,i);
          floorArrIndex++;
        },(res)=>{
          callbackFn(floorArrIndex,res,i);
          floorArrIndex++;
        })
      };
      fn(i)
    }

    Vue.jsonp(`http://deploy.xdf.cn/index/index/getStartClass?`, {
      ccc:this.code,
      soukecityid:this.schoolID,
      callbackQuery: 'callback',
      callbackName: ''
    }).then((res)=>{
      this.fullclasslist=res;
    },(res)=>{

    })



  }
});



// WEBPACK FOOTER //
// ./src/mainm2.js